import { LoggingLevel, LoggingType } from '@/components/webcomponents/Global/logging'

export class AALogger {
  private static logLevel: LoggingLevel = LoggingLevel.Default

  constructor() {
    document.AscendAwesome = document.AscendAwesome || {}
    document.AscendAwesome.LogManager = document.AscendAwesome.LogManager ?? {
      logWarning: this.logWarning.bind(this),
      logError: this.logError.bind(this),
      logDebug: this.logDebug.bind(this),
      logInfo: this.logInfo.bind(this),
    }
  }

  setLogLevel(level: LoggingLevel): void {
    AALogger.logLevel = level
    // You can add validation here if needed
    console.log(`[AA][AALogger] Log level set to ${level}`)
  }

  private logWarning(...args: unknown[]): void {
    this.log(LoggingType.Warning, ...args)
  }

  private logError(...args: unknown[]): void {
    this.log(LoggingType.Error, ...args)
  }

  private logDebug(...args: unknown[]): void {
    this.log(LoggingType.Debug, ...args)
  }

  private logInfo(...args: unknown[]): void {
    this.log(LoggingType.Info, ...args)
  }

  private log(logType: LoggingType, ...args: unknown[]): void {
    if (AALogger.logLevel === LoggingLevel.Off) {
      return
    }
    // Debug is only ever surfaced when Verbose logging is enabled
    if (logType === LoggingType.Debug && AALogger.logLevel !== LoggingLevel.Verbose) {
      return
    }
    const prefix = `[AA][${logType.toUpperCase()}]`
    switch (logType) {
      case LoggingType.Error:
        console.error(prefix, ...args)
        return
      case LoggingType.Warning:
        console.warn(prefix, ...args)
        return
      case LoggingType.Info:
        console.info(prefix, ...args)
        return
      case LoggingType.Debug:
        console.debug(prefix, ...args)
        return
      default:
        return
    }
  }
}
